import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Observable, throwError, BehaviorSubject } from 'rxjs';
//import { catchError, retry } from 'rxjs/operators';
import { APIResponse, Contact } from '../models/models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class ContactService {
    private contactUrl: string = '';

    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
        this.contactUrl = baseUrl + 'api/Contact/';
    }

    public getContactByID(contactID: number) {
        return this.http.get<APIResponse>(this.contactUrl + 'GetContactByID/?contactID=' + contactID);
    }

    public getContactsByTableIdType(tableId: number, contactType: string) {
        return this.http.get<Contact[]>(this.contactUrl + 'GetContactsByTableIdContactType/?tableId=' + tableId + '&contactType=' + contactType);
    }

    public getSearchContactByCarrierID(carrierID: number) {
        return this.http.get<APIResponse>(this.contactUrl + 'GetSearchContactByCarrierID/?carrierID=' + carrierID);
    }

    public getSearchContactByCustomerID(customerID: number) {
        return this.http.get<APIResponse>(this.contactUrl + 'GetSearchContactByCustomerID/?customerID=' + customerID);
    }

    public getContactTitles() {
        return this.http.get<APIResponse>(this.contactUrl + 'GetContactTitles/');
    }

    public deleteContactById(id: number) {
        return this.http.delete<boolean>(this.contactUrl + 'Delete/?id=' + id);
    }

    public unsubscribeContactByEncryptedId(encryptedId: string) {
        return this.http.post<APIResponse>(this.contactUrl + 'UnsubscribeContactByEncryptedId/?encryptedId=' + encodeURIComponent(encryptedId), httpOptions);
    }

    public saveContact(contact: Contact) {
        return this.http.post<Contact>(this.contactUrl + 'Save', contact, httpOptions);
    }

    public setContactEnteredOffer(contactId: number) {
        return this.http.post<APIResponse>(this.contactUrl + 'SetContactEnteredOffer/?contactId=' + contactId, httpOptions);
    }
}
